import React from 'react';
import PageTitle from '../../FormElements/PageTitle';
import LandingPageExitMenu from '../../Navigation/LandingPageExitMenu';
import getLandingImageHeight from '../../../utils/getLandingImageHeight';
import BestBallZoneImage from '../../../../assets/images/bestballzone.jpg';
import useSubscriptionGate from '../../../hooks/useSubscriptionGate';

export default function BestBallZonePage() {
	const { guardSubscription } = useSubscriptionGate();

	const navigateTo = (path) => {
		guardSubscription(() => {
			window.location.href = path;
		});
	};

	return (
		<div className="container p-4 pt-4 lg:py-16 md:px-20">
			<div>
				<PageTitle title="Best Ball Zone" />
			</div>

			<div className="relative mt-4 rounded-lg overflow-hidden shadow-lg">
				<img
					src={BestBallZoneImage}
					alt="Best Ball Zone Hub"
					decoding="async"
					className="block w-full object-cover object-center"
					style={getLandingImageHeight()}
				/>

				<div className="absolute bottom-2 md:bottom-4 left-1/2 z-10 -translate-x-1/2 transform">
					<div className="flex items-center justify-center gap-6 p-3 rounded-full">
						<div
							className="w-12 h-12 flex items-center justify-center bg-blue-500 border border-gray-200 text-white text-2xl rounded-full cursor-pointer hover:scale-105 transition-transform transform backdrop-blur-md"
							onClick={() => navigateTo('/projections')}
							title="Projections"
						>
							📊
						</div>
						<div
							className="w-12 h-12 flex items-center justify-center bg-blue-500 border border-gray-200 text-white text-2xl rounded-full cursor-pointer hover:scale-105 transition-transform transform backdrop-blur-md"
							onClick={() => navigateTo('/spike-volatility-index')}
							title="Player Volatility Index"
						>
							📈
						</div>
						<div
							className="w-12 h-12 flex items-center justify-center bg-blue-500 border border-gray-200 text-white text-2xl rounded-full cursor-pointer hover:scale-105 transition-transform transform backdrop-blur-md"
							onClick={() => navigateTo('/draft-build-spectrum')}
							title="Draft Build Spectrum"
						>
							🕹️
						</div>
						<div
							className="w-12 h-12 flex items-center justify-center bg-blue-500 border border-gray-200 text-white text-2xl rounded-full cursor-pointer hover:scale-105 transition-transform transform backdrop-blur-md"
							onClick={() => navigateTo('/championship-weeks')}
							title="Championship Weeks"
						>
							🏁
						</div>
						<LandingPageExitMenu
							currentPage="best-ball-zone"
							triggerTitle="Leave Best Ball Zone"
							containerClassName="relative w-12 h-12 md:hidden"
							triggerClassName="w-full h-full flex items-center justify-center bg-blue-500 border border-gray-200 text-white text-2xl rounded-full cursor-pointer hover:scale-105 transition-transform transform backdrop-blur-md"
						/>
					</div>
				</div>
				<div className="hidden md:block absolute bottom-4 right-4 z-10">
					<LandingPageExitMenu
						currentPage="best-ball-zone"
						triggerTitle="Leave Best Ball Zone"
					/>
				</div>
			</div>
		</div>
	);
}
